import { ADMIN_TABLES, ADMIN_FLASH } from '../../constants/actions';
import { apiActionCreator, apiMultipleCalls } from '../helpers';
import * as selectors from '../../selectors/admin/tables';
import { currentPath } from '../../selectors/router';
import { getText } from '../../constants/admin/texts';
import { MODELS } from '../../constants/admin/settings';
import { fetchOptions } from './context';
import { push } from 'react-router-redux';
import { openFlash } from './flash';
import { getRandomInt } from '../../lib/number.utils';
import { forEach, get, omit, set } from 'lodash';
import { savePreferences } from '../authentication';
import { preferencesSelector } from '../../selectors/authentication';

export function fetchTableData(apiCall, dataKey, options = {}) {
    const tableIndex = options.tableIndex || 0;
    const requestId = `${tableIndex}-${Date.now()}-${getRandomInt(100000)}`;
    return async (dispatch, getState) => {
        if (!options.noSpinner) {
            dispatch({
                requestId,
                type: ADMIN_TABLES.FETCH_START,
                index: tableIndex
            });
        }
        if (options.pagination && options.pagination.prefKey) {
            savePreferences('tables', { [options.pagination.prefKey]: omit(options.pagination, 'prefKey') || {} })(
                dispatch,
                getState
            );
        }
        if (options.pagination) {
            dispatch(_changePagination(tableIndex, options.pagination.page, options.pagination.resultsPerPage));
        }
        const sort = (options.pagination && options.pagination.sort) || '';
        await apiActionCreator(dispatch, apiCall, response => {
            dispatch({
                type: ADMIN_TABLES.FETCH_OK,
                data: options.transformFunction
                    ? options.transformFunction(response[dataKey], dispatch, getState)
                    : response[dataKey],
                totalResults: response.total,
                index: tableIndex,
                sort: sort[0] === '-' ? sort.substring(1) : sort,
                sortDirection: sort[0] === '-' ? '-' : '',
                requestId
            });
            options.afterDone && options.afterDone(response, dispatch);
        });
    };
}

export function select(id, tableIndex = 0) {
    return {
        type: ADMIN_TABLES.SELECT,
        id,
        index: tableIndex
    };
}

export const deleteTableData = (deleteFunction, model, options = {}) => {
    const tableIndex = options.tableIndex || 0;
    return async (dispatch, getState) => {
        dispatch({ type: ADMIN_TABLES.DISABLE, index: tableIndex });
        const state = getState();
        const tableData = selectors.dataSelector(state, { tableIndex });
        const selected = selectors.selectedSelector(state, { tableIndex });
        const toDelete = tableData.filter(u => selected.includes(u.id));
        const _ok = () => {
            if (model === MODELS.ORGANIZATION) {
                fetchOptions()(dispatch, getState);
            }
            dispatch({ type: ADMIN_TABLES.DELETE, index: tableIndex, removed: selected });
            dispatch({ type: ADMIN_FLASH.OPEN, message: options.okText || getText(model, 'tableDeleteText') });
            options.afterDone && options.afterDone();
        };
        if (options.batch) {
            return await apiActionCreator(dispatch, () => deleteFunction(toDelete.map(del => del.id)), _ok, {
                400: error => {
                    dispatch(openFlash(error.message, 'error'));
                    dispatch({ type: ADMIN_TABLES.DELETE, index: tableIndex, removed: [] });
                }
            });
        } else {
            return apiMultipleCalls(
                dispatch,
                toDelete.map(td => () => {
                    const body = options.body;
                    const extraFields = options.modelBodyField || [];
                    forEach(extraFields, f => (body[f.name] = get(td, f.location)));
                    deleteFunction(td[options.idKey || 'id'], body);
                }),
                _ok
            );
        }
    };
};

export function newAction(model, withSubContext, type) {
    return (dispatch, getState) => {
        dispatch(push(`${currentPath(getState())}${withSubContext ? `/${model}s` : ''}/new?type=${type}`));
    };
}

export function openAction(item, model, withSubContext) {
    return (dispatch, getState) => {
        dispatch(push(`${currentPath(getState())}${withSubContext ? `/${model}s` : ''}/${item}`));
    };
}

export function initTable(tableIndex = 0, model) {
    return {
        index: tableIndex,
        type: ADMIN_TABLES.INITIALIZE,
        model
    };
}

export function updateFilter(tableIndex = 0, name, value) {
    return {
        index: tableIndex,
        type: ADMIN_TABLES.UPDATE_FILTER,
        name,
        value
    };
}

export function refresh(tableIndex = 0) {
    return {
        index: tableIndex,
        type: ADMIN_TABLES.REFRESH
    };
}

export function changeSort(tableIndex = 0, newSort, model) {
    return (dispatch, getState) => {
        const currentSort = selectors.sortSelector(getState(), { tableIndex });
        const currentDirection = selectors.sortDirectionSelector(getState(), { tableIndex });
        const newDirection = newSort === currentSort ? (currentDirection ? '' : '-') : '';
        const preferences = { ...preferencesSelector(getState()) };
        set(preferences, `tables.${model}.sort`, `${newDirection}${newSort}`);
        dispatch({
            index: tableIndex,
            type: ADMIN_TABLES.SORT,
            sort: newSort,
            direction: newDirection
        });
    };
}

export function resetSelection(tableIndex = 0) {
    return { type: ADMIN_TABLES.DELETE, index: tableIndex, removed: [] };
}

export function search(tableIndex = 0, query) {
    return { type: ADMIN_TABLES.SEARCH, index: tableIndex, query };
}

function _changePagination(tableIndex, pageNumber, resultsPerPage) {
    return {
        index: tableIndex,
        type: ADMIN_TABLES.CHANGE,
        currentPage: pageNumber,
        resultsPerPage: resultsPerPage
    };
}



// WEBPACK FOOTER //
// ./src/actions/admin/tables.js